// Diagnostics that should never reach production consoles.
export const devWarn = (...args) => {
  if (process.env.NODE_ENV !== "production") console.warn(...args);
};
